module.exports = __webpack_public_path__ + "ec7dcf66a3dd0750e2ddea2396c3ddc2.pdf";